import { FlashCardDeck as InnerDeck } from "@/pages/FlashCards";
export default function FlashCardDeck(props) { return <InnerDeck {...props} />; }
